import axios from 'axios'

const changeEditorModule = {
  state: () => ({
    changeEditorVehicles: [],
    changeEditorDrivers : []
  }),

  getters: {
    getChangeEditorVehicles (state) {
      return state.changeEditorVehicles
    },

    getChangeEditorDrivers (state) {
      return state.changeEditorDrivers
    }
  },

  mutations: {
    setChangeEditorVehicles (state, vehicles) {
      state.changeEditorVehicles = vehicles
    },

    setChangeEditorDrivers (state, drivers) {
      state.changeEditorDrivers = drivers
    }
  },

  actions: {
    fetchChangeEditorVehicles ({ commit }) {
      if (localStorage.getItem('accessToken')) {
        const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

        axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle`, axiosConfig).then(r => {
          commit('setChangeEditorVehicles', r.data)
        }).catch(e => {
          console.log(e)
        })
      }
    },

    fetchChangeEditorDrivers ({ commit }) {
      if (localStorage.getItem('accessToken')) {
        const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

        axios.get(`${process.env.VUE_APP_API_BASE_URL}Driver`, axiosConfig).then(r => {
          commit('setChangeEditorDrivers', r.data)
        }).catch(e => {
          console.log(e)
        })
      }
    }
  }
}

export default changeEditorModule
